const templateImports = import.meta.glob(
  "../app/forms/templates/**/*.template.{js,jsx}",
  {
    import: "default",
    eager: true
  }
)

const settingsImports = import.meta.glob(
  "../app/forms/templates/**/*.settings.js",
  {
    import: "settings",
    eager: true
  }
)

const cssImports = import.meta.glob("../app/forms/templates/**/*.css", {
  import: "default",
  eager: true,
  query: "?raw"
})

const templates = Object.entries(templateImports).reduce(
  (templates, [templatePath, templateModule]) => {
    const Template = templateModule

    const settingsPath = templatePath.replace(
      /\.template\.(js|jsx)$/,
      ".settings.js"
    )
    const cssPath = templatePath.replace(/\.template\.(js|jsx)$/, ".css")

    Template.settings = settingsImports[settingsPath]
    Template.css = cssImports[cssPath]

    return { ...templates, [Template.displayName]: Template }
  },
  {}
)

export default templates
